import './ProductDetail.css';
import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import MockProducts from '../../MockProducts/MockProducts.js';
import WhatsappVerde from '../assets/Home/whatsappVerde.png'
import MF899 from '../assets/ProductDetail/MF899.png';
import MF890 from '../assets/ProductDetail/MF890.png';
import MF889 from '../assets/ProductDetail/MF889.png';
import MF910H from '../assets/ProductDetail/MF910H.png';
import MF910 from '../assets/ProductDetail/MF910.png';
import MF930 from '../assets/ProductDetail/MF930.png';
import MF899F from '../assets/ProductDetail/MF899F.png';
import MF899T from '../assets/ProductDetail/MF899T.png';
import MF89925 from '../assets/ProductDetail/MF899-25.png';
import MF898 from '../assets/ProductDetail/MF898.png';
import MF897 from '../assets/ProductDetail/MF897.png';
import MF889F25 from '../assets/ProductDetail/MF889F-25.png';
import MF889A from '../assets/ProductDetail/MF889A.png';
import MF910G from '../assets/ProductDetail/MF910G.png';
import MF88925 from '../assets/ProductDetail/MF889-25.png';
import MF883 from '../assets/ProductDetail/MF883.png';
import MF840 from '../assets/ProductDetail/MF840.png';
import MF882 from '../assets/ProductDetail/MF882.png';
import MF88125G from '../assets/ProductDetail/MF881-25G.png';
import MF881 from '../assets/ProductDetail/MF881.png';
import MF88125 from '../assets/ProductDetail/MF881-25.png';
//ELECTRONICA
import MF281 from '../assets/ProductDetail/MF281.png';
import MF282 from '../assets/ProductDetail/MF282.png';
import MF2822 from '../assets/ProductDetail/MF282-2.png';
import MF210 from '../assets/ProductDetail/MF210.png';
import MF211 from '../assets/ProductDetail/MF211.png';
import MF4150 from '../assets/ProductDetail/MF4150.png';
import MF4160 from '../assets/ProductDetail/MF4160.png';
import MF5360 from '../assets/ProductDetail/MF5360.png';
import MF5380 from '../assets/ProductDetail/MF5380.png';
import MF1308 from '../assets/ProductDetail/MF1308.png';
import MF1309 from '../assets/ProductDetail/MF1309.png';
import MF1560 from '../assets/ProductDetail/MF1560.png';
//AUTOMOTRIZ
import MF203 from '../assets/ProductDetail/MF203.png';
import MF212 from '../assets/ProductDetail/MF212.png';
import MF892 from '../assets/ProductDetail/MF892.png';
//PANELES SOLARES
import MF962 from '../assets/ProductDetail/MF962.png';
import MF962L from '../assets/ProductDetail/MF962L.png';
import MF961 from '../assets/ProductDetail/MF961.png';
//IMPERMEABILIZANTES
import MF886F from '../assets/ProductDetail/MF886F.png';
import MF521 from '../assets/ProductDetail/MF521.png';
import MF860F from '../assets/ProductDetail/MF860F.png';
import MF2000B from '../assets/ProductDetail/MF2000B.png';
import MF2000G from '../assets/ProductDetail/MF2000G.png';
import MF2000H from '../assets/ProductDetail/MF2000H.png';
import MF860L from '../assets/ProductDetail/MF860L.png';

function ProductDetail() {
    const { id } = useParams();
    const product = MockProducts.find((item) => item.id === parseInt(id));
    const [selectedContent, setSelectedContent] = useState(1);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    if (!product) {
        return <p>Producto no encontrado.</p>;
    }

    // Cargar las imágenes específicas basadas en el id
    const imageMap = {
        // 1: MF930,
        2: MF910H,
        3: MF910G,
        4: MF910,
        // 5: MF899F,
        // 6: MF899T,
        // 7: MF89925,
        8: MF899,
        // 9: MF898,
        // 10: MF897,
        11: MF890,
        // 12: MF889F25,
        // 13: MF889A,
        // 14: MF88925,
        15: MF889,
        // 16: MF883,
        // 17: MF840,
        // 18: MF882,
        // 19: MF88125G,
        // 21: MF88125,
        // 22: MF881,
        23: MF281,
        24: MF282,
        25: MF2822,
        26: MF210,
        27: MF211,
        28: MF4150,
        29: MF4160,
        30: MF5360,
        31: MF5380,
        32: MF1308,
        33: MF1309,
        34: MF1560,
        35: MF203,
        36: MF212,
        37: MF892,
        38: MF962,
        39: MF962L,
        40: MF961,
        41: MF886F,
        42: MF521,
        43: MF860F,
        44: MF860L,
        45: MF2000B,
        46: MF2000G,
        47: MF2000H
        // Agrega el resto de imágenes aquí, según corresponda
    };

    const imageSrc = imageMap[product.id] || MF899;

    // Convertir características en una lista si es posible
    const caracteristicasArray = product.caracteristicasRendimiento.split('.').filter(item => item.trim() !== "");

    const industryColors = {
        Automotriz: 'green',
        Construcción: 'red',
        Electrónico: 'blue',
        PanelesSolares: 'orange',
        Impermeabilizantes: 'yellow'
    };

    const borderColor = industryColors[product.categoria] || 'gray';

    // Mapeo entre ID de producto y nombre real del PDF
    const pdfMap = {
        2: 'MF910H.pdf',
        3: 'MF910G.pdf',
        4: 'MF910.pdf',
        8: 'MF899.pdf',
        15: 'MF889.pdf',
        11: 'MF890.pdf',
    };

    // Mapeo entre ID de producto y MSDS correspondiente
    const msdsMap = {
        2: 'MSDS-MF910.pdf',
        3: 'MSDS-MF910.pdf',
        4: 'MSDS-MF910.pdf',
        8: 'MSDS-MF899.pdf',
        15: 'MSDS-MF889.pdf',
        11: 'MSDS-MF890.pdf',
    };

    // Función para descargar ambos archivos con un pequeño delay
    const handleDownloadBoth = () => {
        const ficha = pdfMap[product.id];
        const msds = msdsMap[product.id];
        if (ficha) {
            const link1 = document.createElement('a');
            link1.href = `/pdfs/${ficha}`;
            link1.download = ficha;
            document.body.appendChild(link1);
            link1.click();
            document.body.removeChild(link1);
        }
        if (msds) {
            setTimeout(() => {
                const link2 = document.createElement('a');
                link2.href = `/pdfs/${msds}`;
                link2.download = msds;
                document.body.appendChild(link2);
                link2.click();
                document.body.removeChild(link2);
            }, 700); // 700 ms de delay
        }
    };

    return (
        <>
            <Navbar />
            <div className="main-content">
                <div className="breadcrumb">
                    <span
                        className="breadcrumb-clickable"
                        onClick={() => navigate('/')}
                    >
                        Inicio
                    </span>
                    &gt;

                    <span
                        className="breadcrumb-clickable"
                        onClick={() => navigate('/productos', { state: { tab: product.categoria } })}
                    >
                        Productos
                    </span>
                    &gt;

                    <span
                        className="breadcrumb-clickable"
                        onClick={() => navigate('/productos', { state: { tab: product.categoria } })}
                    >
                        {product.categoria}
                    </span>
                    &gt;

                    <span className="breadcrumb-active">
                        {product.nombre}
                    </span>
                </div>
                <div className="product-detail-container">
                    <div className="product-image">
                        <img src={imageSrc} alt={product.nombre} />
                    </div>
                    <div
                        className="product-info"
                    >
                        <div
                            style={{
                                borderLeft: `5px solid ${borderColor}`,
                                paddingLeft: '15px', // separa contenido de la línea
                                display: 'inline-flex',
                                flexDirection: 'column',
                                gap: '4px', // separación vertical entre los textos
                            }}
                        >
                            <h4 className="titleProduct">{product.nombre}</h4>
                            <h8 className="titleIndustria">Industria: {product.categoria}</h8>
                        </div>
                        <hr className="divider" />
                        <ul className="content-tabs">
                            <li
                                className={selectedContent === 1 ? "active" : ""}
                                onClick={() => setSelectedContent(1)}
                            >
                                DESCRIPCIÓN DEL PRODUCTO
                            </li>
                            <li
                                className={selectedContent === 2 ? "active" : ""}
                                onClick={() => setSelectedContent(2)}
                            >
                                CARÁCTERISTICAS DE RENDIMIENTO
                            </li>
                        </ul>
                        <div className="content-text">
                            {selectedContent === 1 && <p className="justified">{product.descripcionProducto}</p>}
                            {selectedContent === 2 && (
                                <ul className="justified list-style">
                                    {caracteristicasArray.map((caracteristica, index) => (
                                        <li key={index}>{caracteristica}</li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div className="download-buttons">
                            {(pdfMap[product.id] || msdsMap[product.id]) ? (
                                <button onClick={handleDownloadBoth}>
                                    Descargar ficha técnica y hoja de seguridad
                                </button>
                            ) : (
                                <button disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>Ficha técnica no disponible</button>
                            )}
                        </div>
                    </div>
                </div>
                <div className="additional-info">
                    {product.normasAplicables && (
                        <div className="info-section">
                            <h4 className='titleSection'>NORMAS APLICABLES</h4>
                            <ul className="list-style">
                                {product.normasAplicables.split('.').filter(item => item.trim() !== "").map((norma, index) => (
                                    <li key={index}>{norma.trim()}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {product.colores && product.colores.trim() !== "" && (
                        <div className="info-section">
                            <h4 className='titleSection'>COLORES</h4>
                            <ul className="list-style">
                                {product.colores.split('. ').map((color, index) => (
                                    <li key={index}>{color}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {product.packaging && product.packaging.trim() !== "" && (
                        <div className="info-section">
                            <h4 className='titleSection'>PACKAGING</h4>
                            <ul className="list-style">
                                {product.packaging.split('.').filter(item => item.trim() !== "").map((pack, index) => (
                                    <li key={index}>{pack.trim()}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {product.vidaUtil && product.vidaUtil.trim() !== "" && (
                        <div className="info-section">
                            <h4 className='titleSection'>VIDA UTIL/ALMACENAMIENTO</h4>
                            <ul className="list-style">
                                {product.vidaUtil.split('.').filter(item => item.trim() !== "").map((pack, index) => (
                                    <li key={index}>{pack.trim()}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
            <button
                className="whatsapp-button"
                onClick={() => window.open("https://wa.me/+5491151489606", "_blank")}
            >
                <img src={WhatsappVerde} alt="WhatsApp" />
            </button>
        </>
    );
}

export default ProductDetail;
